import { AxiosResponse } from "axios";
import { Base } from "./bases/base.service";

export default class BundleCourseService {
  public getBundleCourse(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().get("bundle-course/get", { params });
  }
  public getBundleCourseDetail(slug: string): Promise<AxiosResponse<any>> {
    return Base().get(`bundle-course/detail/${slug}`);
  }
  public getBundleCourseRating(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().get(`bundle-course/ratings/${params?.id}`, {
      params,
    });
  }
}
